module.exports = __webpack_public_path__ + "img/tally-3.4f367219.svg";